import { type FC } from "react";
import { Alert } from "@chakra-ui/react";

import { NotificationBlock } from "./notification-block";
import { useNotificationSearchParam } from "../lib/use-notification-search-param";

export const UrlNotificationBlock: FC<Omit<Alert.RootProps, "status">> = (
  props,
) => {
  const notification = useNotificationSearchParam();

  if (!notification) return null;

  return (
    <NotificationBlock
      {...props}
      status={notification.status}
      message={notification.message}
    />
  );
};
